import { Logger } from "@sunrun/sales-experience-shared";

const logger = new Logger({
  runtime: "web",
  application: "SalesExp",
  // transports: [rollbarTransport(rollbar)],
});

export { logger };
